import React from 'react';
import { FaHeart } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="relative bg-[#0a0a0f] border-t border-white/5 text-gray-400 py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* About Section */}
          <div data-aos="fade-up">
            <h3 className="text-lg font-medium text-white mb-4">
              About Me
            </h3>
            <p className="text-sm leading-relaxed text-gray-400">
              Full Stack Developer passionate about building scalable web applications and exploring new technologies.
            </p>
          </div>

          {/* Quick Links */}
          <div data-aos="fade-up" data-aos-delay="100">
            <h3 className="text-lg font-medium text-white mb-4">
              Quick Links
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#home" className="text-gray-400 hover:text-white transition-colors duration-300">
                  Home
                </a>
              </li>
              <li>
                <a href="#projects" className="text-gray-400 hover:text-white transition-colors duration-300">
                  Projects
                </a>
              </li>
              <li>
                <a href="#skills" className="text-gray-400 hover:text-white transition-colors duration-300">
                  Skills
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors duration-300">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-aos="fade-up" data-aos-delay="200">
            <h3 className="text-lg font-medium text-white mb-4">
              Contact Info
            </h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Kathmandu, Nepal</li>
              <li>+977 9827489335</li>
              <li>dev.roshankarki@gmail.com</li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/5 mt-8 pt-8 text-center">
          <p className="text-xs text-gray-500 flex items-center justify-center gap-2">
            Made with <FaHeart className="text-gray-400" /> by Roshan Karki © {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
